import { render, staticRenderFns } from "./PuceReport.vue?vue&type=template&id=6d74f6f0"
import script from "./PuceReport.vue?vue&type=script&lang=js"
export * from "./PuceReport.vue?vue&type=script&lang=js"
import style0 from "./PuceReport.vue?vue&type=style&index=0&id=6d74f6f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports